import http from './http.config'

export const fetchAppInit = () =>
  http.get('/app-init').then((res) => res.data)

